export default "__VITE_ASSET__DAAk$me$__"